import React from 'react';
import './gentleMegagripSection.scss';
import {useTranslation} from "react-i18next";

const GentleMegagripSection = () => {
	const { t, i18n } = useTranslation();
	const { language } = i18n;
	
	return (
		<div className="gentleMegagrip">
			<div className={`main__bg_animations_item c0`} />
			<div className={`main__bg_animations_item c1`} />
			<div className={`main__bg_animations_item c2`} />
			<div className="gentleMegagrip__content">
				<div className="gentleMegagrip__content_header">
					<h3>{t('gentleMegagrip.title')}</h3>
				</div>
				<div className="gentleMegagrip__content_text">
					<p>{t('gentleMegagrip.description1')}</p>
					{
						language === 'no' ? (
							<p>{t('gentleMegagrip.description3')}</p>
						) : (
							<p>{t('gentleMegagrip.description2')}</p>
						)
					}
				</div>
				<div className="gentleMegagrip__content_btn">
					<button className={`mainButton`}>
						<span>{t('buttons.shopNow')}</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default GentleMegagripSection;